const tableTitlePlaces = {
  title: 'Lugares',
  placeholder: 'Buscar'
};

export default tableTitlePlaces;
